/**
 * Variáveis de ambiente do Vite, lidas **num lugar só** e com valor de reserva.
 *
 * O motivo do `??` não é preguiça: `import.meta.env.VITE_*` é substituído em tempo de build, e um
 * `.env` incompleto (ou um teste, que não carrega `.env` nenhum) deixa a variável `undefined`. Sem
 * reserva isso vira um `alt=""` no logotipo — uma falha de acessibilidade silenciosa, que nenhum
 * build quebra e ninguém nota.
 *
 * 🚨 Nada de segredo aqui: tudo que entra num `VITE_*` vai compilado no bundle e é público.
 */

export const APP_NOME = import.meta.env.VITE_APP_NOME || 'Tríplice Capital';

/** `dev` | `staging` | `prod` | `ci` — vira o selo de ambiente na Topbar (oculto em prod). */
export const AMBIENTE = import.meta.env.VITE_AMBIENTE || '';

/** Fora de produção o selo aparece; em prod o ambiente é o esperado e o selo seria ruído. */
export const mostrarSeloDeAmbiente = (): boolean => AMBIENTE !== '' && AMBIENTE !== 'prod';
